import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'
import {buildCustomQueryParams} from '../utils/custom-utils'

/**
 * Custom hook to fetch popular suggestions
 */
export const usePopularSuggestions = (params = {}, obj = {}) => {
    const {locale} = useMultiSite()
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const localeValue = locale?.id

    const {apiPath, queryKey} = useMemo(() => {
        const query = params?.parameters?.q || ''
        const encodedQuery = encodeURIComponent(query)
        const updatedParams = {
            ...params?.parameters,
            q: encodedQuery
        }
        const customQuery = buildCustomQueryParams(updatedParams)
        const queryParts = []

        if (customQuery) queryParts.push(customQuery)
        queryParts.push(`locale=${localeValue}`)

        return {
            apiPath: `popular-suggestions?${queryParts.join('&')}`,
            queryKey: ['custom', 'popularSuggestions', query]
        }
    }, [params?.parameters?.q, localeValue])

    const queryResult = useQuery({
        queryKey,
        queryFn: () =>
            doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName: 'suggestions',
                apiPath
            }),
        enabled: !!obj?.enabled
    })

    return queryResult
}
